import type {MarkdownProps} from '@travel-frontend/ui-components';

import {css} from '@emotion/react';
import {Markdown} from '@travel-frontend/ui-components';

export const TooltipMarkdown = ({
  value,
  copyToClipboardButtonProps,
  ...restProps
}: MarkdownProps) => {
  return (
    <Markdown
      {...restProps}
      value={value}
      copyToClipboardButtonProps={{
        size: 'small',
        category: 'tertiary',
        variant: 'interaction',
        css: css`
          padding: 0 4px;
        `,
        ...copyToClipboardButtonProps,
      }}
    />
  );
};
